export default {
    votePackage:  0,
    bayesianVote: 1,
    singleVote:  2,
};